import { type IProductSearchRequest, ProductSearchResponseSchema } from '@/schemas/catalog/catalogSchemas'
import { type IProductSearchResult } from '@/schemas/catalog/product'
import { api, apiService } from '@/services/core/ApiService'

const search = (body: IProductSearchRequest): Promise<IProductSearchResult[]> =>
    apiService(api)
        .post('product/search', body, ProductSearchResponseSchema)
        .onError(() => {}, { useDefaultErrorHandler: false })
        .execute()

// ===== BUSCA DO NAVBAR (POST product/search) =====

/**
 * Autocomplete: até 20 produtos pelo texto (a API normaliza acento e caixa). Texto vazio devolve `[]` sem chamar a
 * API. Sem toast: o autocomplete mostra "nenhum resultado" ou nada.
 */
export const searchProductsService = (keyword: string): Promise<IProductSearchResult[]> => {
    const trimmed = keyword.trim()
    return trimmed ? search({ keyword: trimmed }) : Promise.resolve([])
}

/** Produtos com a tag (igualdade, sem caixa). */
export const searchProductsByTagService = (tag: string): Promise<IProductSearchResult[]> => search({ tagsSearch: tag })
